import axios from "axios";
import { API_ENDPOINTS } from "../api-urls";


// ** Helper function to get token **
const getAuthToken = () => {
  const token = localStorage.getItem("authToken");
  return token ? `Bearer ${token}` : null;
};

// ** Fetch All Addresses **
export const fetchAddressesAPI = async () => {
  const token = getAuthToken();
  if (!token) throw new Error("Authentication token missing.");

  const response = await axios.get(`${API_ENDPOINTS.addresses}/get-allUserAddresses`, {
    headers: { Authorization: token },
  });

  return response.data.addresses;
};

// ** Add New Address **
export const addNewAddressAPI = async (addressData) => {
  const token = getAuthToken();
  if (!token) throw new Error("Authentication token missing.");

  const response = await axios.post(`${API_ENDPOINTS.addresses}/add-address`, addressData, {
    headers: { Authorization: token },
  });

  return response.data.address;
};

// ** Update Address **
export const updateAddressAPI = async (id, updatedAddress, userId) => {
  if (!userId) throw new Error("User ID is required.");

  const response = await axios.put(
    `${API_ENDPOINTS.addresses}/update-address/${id}`,
    { ...updatedAddress, _id: id, user_id: userId },
    { headers: { Authorization: getAuthToken() } }
  );

  return response.data;
};

// ** Delete Address **
export const deleteAddressAPI = async (id) => {
  const token = getAuthToken();
  if (!token) throw new Error("Authentication token missing.");

  const response = await axios.delete(`${API_ENDPOINTS.addresses}/delete-address/${id}`, {
    headers: { Authorization: token },
  });

  return response.status === 200 || response.data.success ? id : null;
};
